import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-section-features',
    templateUrl: './section-features.component.html',
    styleUrls: ['./section-features.component.scss'],
    standalone: false
})
export class SectionFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
